import { Color } from 'antd/es/color-picker';
import React from 'react';
import Select from 'react-select';

const CustomSelect = ({
    options,
    value,
    onChange,
    isDisabled = false,
    isLoading = false,
    isClearable = false,
    isSearchable = true,
    placeholder = 'Select...',
    className = '',
    error = null,
    name,
    ...props
}) => {
    const customStyles = {
        control: (provided) => ({
            ...provided,
            width: "100%",
            minHeight: '36px',
            height: '36px',
            fontSize: '14px',
            border: error ? 'none' : '1px solid #ddd',
            borderBottom: error ? '2px solid #ff4d4f !important' : '1px solid #ddd',
            boxShadow: 'none',
            '&:hover': {
                borderBottom: error ? '2px solid #ff4d4f!important' : '1px solid #ddd',
            },
            borderRadius: '4px',
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '36px',
            padding: '0 8px'
        }),
        input: (provided) => ({
            ...provided,
            margin: '0px',
            paddingBottom: '0',
            paddingTop: '0',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '36px'
        }),
        clearIndicator: (provided) => ({
            ...provided,
            padding: '4px'
        }),
        option: (provided) => ({
            ...provided,
            fontSize: '14px',
            padding: '8px 12px'
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: '14px'
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: '14px'
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: error ? '#ff4d4f !important' : '#999',
            '&:hover': {
                color: error ? '#ff4d4f !important' : '#999',
            },
        }),
    };

    return (
        <div className={`custom-select-container ${error ? 'has-error' : ''}`}>
            <Select
                options={options}
                value={value}
                onChange={onChange}
                isDisabled={isDisabled}
                styles={customStyles}
                name={name}
                classNamePrefix="react-select"
                {...props}
            />
            {error && <div className="error-message">{error}</div>}
        </div>
    );
};

export default CustomSelect;